import React, { useState, useEffect } from 'react';
import './TableTwo.css';
import Spinner from '../../Spinner';
const TableTwo = (props) => {
    const [rows, setRows] = useState([]);
    const [sortConfig, setSortConfig] = useState(null);
    useEffect(() => {
        setRows(props.rows);
    }, [props.rows]);
    const onHeaderClick = (column) => {
        let direction = 'asc';
        if (sortConfig && sortConfig.column === column && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        // Create a new array by spreading the existing rows array and sort it based on the values of the
        // clicked column and the sorting direction.
        // Return -1 if a should come before b, 1 if a should come after b, and 0 if they are equal.
        const sortedData = [...rows].sort((a, b) => {
            if (a[column] < b[column]) {
                return direction === 'asc' ? -1 : 1;
            }
            if (a[column] > b[column]) {
                return direction === 'asc' ? 1 : -1;
            }
            return 0;
        });
        setRows(sortedData);
        setSortConfig({ column, direction });
    };
    return (React.createElement("div", { style: { overflowX: 'hidden', ...props.style } },
        React.createElement("table", { className: "styled-table" },
            React.createElement("thead", null,
                React.createElement("tr", { style: { cursor: 'pointer' } }, props.headers.map((header) => (React.createElement("th", { key: header.key, onClick: () => onHeaderClick(header.key) },
                    React.createElement("span", null,
                        header.title,
                        header.filterType === 'sortOrder' &&
                            sortConfig?.column === header.key &&
                            (sortConfig?.direction === 'asc' ? '▲' : '▼'))))))),
            props?.loading && React.createElement(Spinner, { title: "H\u00E4mtar data... " }),
            !props?.loading && (React.createElement("tbody", null, rows.map((row) => (React.createElement("tr", { key: `row-${row.id}`, className: "hoverable-row", style: { cursor: props.cursorStyle ? props.cursorStyle : 'pointer' } }, Object.keys(row).map((key) => {
                if (props.headers.some((header) => header.key === key) &&
                    key !== 'id' &&
                    !props.ignoreKeyFilters?.includes(key)) {
                    return (React.createElement("td", { onClick: () => props.onClick?.(row[props.onClickValue ?? 'id']), key: key }, row[key]));
                }
                else {
                    return null;
                }
            })))))))));
};
export default TableTwo;
